// Keeps the screen on while in a room. The OS/browser releases a wake lock
// whenever the tab is hidden, so we re-request it on visibilitychange.
// (A dropped screen used to drop the socket and lose the room.)

let sentinel: any = null;
let wanted = false;

async function request() {
  if (sentinel || !wanted) return;
  try {
    sentinel = await (navigator as any).wakeLock?.request("screen");
    sentinel?.addEventListener?.("release", () => { sentinel = null; });
  } catch {
    sentinel = null; // denied (low battery, unsupported) — nothing else we can do
  }
}

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") void request();
});

export const wakeLock = {
  enable() { wanted = true; void request(); },
  disable() {
    wanted = false;
    try { sentinel?.release(); } catch { /* ignore */ }
    sentinel = null;
  },
};
